import { render, staticRenderFns } from "./ContentMenu.vue?vue&type=template&id=4cbf5c72&scoped=true&"
import script from "./ContentMenu.vue?vue&type=script&lang=js&"
export * from "./ContentMenu.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ContentMenu.vue?vue&type=style&index=0&id=4cbf5c72&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4cbf5c72",
  null
  ,true
)

export default component.exports